import { render, staticRenderFns } from "./OwnershipsViewer.vue?vue&type=template&id=a002e51c&scoped=true&lang=pug"
import script from "./OwnershipsViewer.vue?vue&type=script&lang=js"
export * from "./OwnershipsViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a002e51c",
  null
  
)

export default component.exports